import React, { memo } from "react";
import { useDashboardContext } from "../../contexts/dashboard-context";
import { useErrorHandling } from "../../hooks/useErrorHandling";
import { useGoogleAnalytics } from "../../hooks/useGoogleAnalytics";
import { showEventDialogAsync } from "../dialogs/events-dialog";
import { IconButton } from "../icon-button";

export const EventsButton = memo(() => {
	const { createErrorHandler } = useErrorHandling();

	const googleAnalytics = useGoogleAnalytics();

	const dashboard = useDashboardContext();
	const onClick = () => {
		googleAnalytics.trackEventToGa({ trackingAction: "EventsClicked" });
		showEventDialogAsync()
			.then((result) => {
				if (!result) return;
				if (!dashboard.canChangeCalendarEvents(result)) return;

				googleAnalytics.trackEventToGa({
					trackingAction: "CopySpreadsChanged",
				});
				dashboard.changeCalendarEvents(result);
			})
			.catch(createErrorHandler());
	};

	return <IconButton iconName="calendar" onClick={onClick} elevated />;
});
EventsButton.displayName = "EventsButton";
